import isArchived from 'archive/isArchived';
import {MODEL_FIELD_DISPLAY_NAME} from 'instruments/equipment/EquipmentConstants';
import {isRequiredLinkTagSchema, RequiredLink, SchemaField} from 'schemas/fields/SchemaFieldConstants';

/**
 * Get required link from a tag schema's Model schema field. Primarily used for tag schemas with equipment SSI
 */
export function getModelRequiredLinkFromTagSchema(tagSchema: {
  allFields: Array<SchemaField>;
}): RequiredLink | null {
  const modelField = tagSchema.allFields.find((field) => field.name === MODEL_FIELD_DISPLAY_NAME);
  return modelField?.requiredLink ?? null;
}

/**
 * Returns true if the equipment schema's Model field links to an archived schema.
 */
export function hasArchivedModelSchema(tagSchema: {allFields: Array<SchemaField>}): boolean {
  const modelLink = getModelRequiredLinkFromTagSchema(tagSchema);
  return modelLink != null && isRequiredLinkTagSchema(modelLink) && isArchived(modelLink.tagSchema);
}
